// import React, { useState } from "react";
// import { Button, Container } from "react-bootstrap";

// // ─── Colour tokens ───────────────────────────────────────────────────────────
// const NAVY = "#1a237e";

// // ─── All team data from screenshots ──────────────────────────────────────────
// const DIVISIONS = {
//   A: {
//     label: "DIVISION A",
//     description:
//       "4-pool with Quarter-final, Semi-final & Finals 11th & 12th ranked teams to be relegated to Division 'B'",
//     pools: {
//       "Pool A": [
//         "HOCKEY PUNJAB",
//         "HOCKEY CHANDIGARH",
//         "HOCKEY MAHARASHTRA",
//       ],
//       "Pool B": [
//         "HOCKEY JHARKHAND",
//         "DADRA & NAGAR HAVELI AND DAMAN & DIU HOCKEY",
//         "HOCKEY UNIT OF TAMIL NADU",
//       ],
//       "Pool C": [
//         "UTTAR PRADESH HOCKEY",
//         "HOCKEY HARYANA",
//         "MANIPUR HOCKEY",
//       ],
//       "Pool D": [
//         "HOCKEY MADHYA PRADESH",
//         "HOCKEY ASSOCIATION OF ODISHA",
//         "KERALA HOCKEY",
//       ],
//     },
//   },
//   B: {
//     label: "DIVISION B",
//     description:
//       "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'A' and last two ranked teams to be relegated to Division 'C'",
//     pools: {
//       "Pool A": [
//         "DELHI HOCKEY",
//         "HOCKEY GUJARAT",
//         "HOCKEY BENGAL",
//         "TELANGANA HOCKEY",
//         "HOCKEY UTTARAKHAND",
//       ],
//       "Pool B": [
//         "HOCKEY KARNATAKA",
//         "CHHATTISGARH HOCKEY",
//         "HOCKEY ARUNACHAL",
//         "HOCKEY HIMACHAL",
//         "HOCKEY BIHAR",
//       ],
//     },
//   },
//   C: {
//     label: "DIVISION C",
//     description:
//       "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'B'",
//     pools: {
//       "Pool A": [
//         "HOCKEY ANDHRA PRADESH",
//         "HOCKEY MIZORAM",
//         "LE PUDUCHERRY HOCKEY",
//         "ASSAM HOCKEY",
//       ],
//       "Pool B": [
//         "GOANS HOCKEY",
//         "HOCKEY JAMMU & KASHMIR",
//         "HOCKEY RAJASTHAN",
//         "TRIPURA",
//       ],
//     },
//   },
// };

// // ─── Hockey stick icon (left header) ─────────────────────────────────────────
// function HockeyStickIcon({ color = "#FFD600", size = 28 }) {
//   return (
//     <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
//       {/* stick shaft */}
//       <line x1="12" y1="8" x2="36" y2="52" stroke={color} strokeWidth="5" strokeLinecap="round" />
//       {/* blade */}
//       <path d="M36 52 Q44 56 50 50 Q54 44 44 40 L36 52Z" fill={color} />
//       {/* puck */}
//       <ellipse cx="48" cy="54" rx="6" ry="3" fill={color} opacity="0.6" />
//     </svg>
//   );
// }

// // ─── Hockey player silhouette (right header) ──────────────────────────────────
// function HockeyPlayerIcon({ color = "#FFD600", size = 40 }) {
//   return (
//     <svg width={size} height={size} viewBox="0 0 100 100" fill={color}>
//       {/* head */}
//       <circle cx="62" cy="12" r="9" />
//       {/* body */}
//       <path d="M62 21 L55 50 L45 70 L52 72 L60 55 L65 70 L72 68 L65 48 L68 21Z" />
//       {/* left arm holding stick */}
//       <path d="M58 28 L30 45 L28 52 L20 58 L16 54 L24 46 L26 40 L55 24Z" />
//       {/* stick blade */}
//       <path d="M16 54 Q8 60 10 66 Q14 70 22 64 L28 52Z" />
//     </svg>
//   );
// }

// // ─── Pool card component ──────────────────────────────────────────────────────
// function PoolCard({ poolName, teams }) {
//   return (
//     <div
//       style={{
//         background: NAVY,
//         borderRadius: "14px",
//         padding: "18px 20px 20px",
//         color: "#fff",
//         minWidth: 0,
//       }}
//     >
//       {/* Pool header */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginBottom: "14px",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//           <HockeyStickIcon color="#FFD600" size={28} />
//           <span style={{ fontWeight: 700, fontSize: "16px" }}>
//             Pool{" "}
//             <span style={{ color: "#FFD600" }}>
//               {poolName.replace("Pool ", "")}
//             </span>
//           </span>
//         </div>
//         <HockeyPlayerIcon color="#FFD600" size={40} />
//       </div>

//       {/* Team list */}
//       <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//         {teams.map((team) => (
//           <div
//             key={team}
//             style={{ display: "flex", alignItems: "center", gap: "10px" }}
//           >
//             <div
//               style={{
//                 width: "28px",
//                 height: "28px",
//                 borderRadius: "50%",
//                 background: "rgba(255,255,255,0.15)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//               }}
//             >
//               <HockeyStickIcon color="#FFD600" size={16} />
//             </div>
//             <span
//               style={{
//                 fontWeight: 600,
//                 fontSize: "13px",
//                 textTransform: "uppercase",
//                 lineHeight: 1.3,
//               }}
//             >
//               {team}
//             </span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// // ─── Main page component ──────────────────────────────────────────────────────
// export default function SubJuniorMensHockeyTeams() {
//   const divisionKeys = Object.keys(DIVISIONS);
//   const [activeDivision, setActiveDivision] = useState("A");

//   const division = DIVISIONS[activeDivision];
//   const poolEntries = Object.entries(division.pools);

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         backgroundImage: "url('/img/bghockyimg.jpeg')",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundAttachment: "fixed",
//         backgroundRepeat: "no-repeat",
//       }}
//     >
//       {/* ← Return */}
//       <div style={{ padding: "16px 20px", textAlign: "left" }}>
//         <Button
//           href="/sub-junior-mens-hockey-2026"
//           style={{
//             backgroundColor: NAVY,
//             borderColor: NAVY,
//             fontSize: "12px",
//             padding: "6px 16px",
//           }}
//         >
//           ← Return
//         </Button>
//       </div>

//       <Container style={{ maxWidth: "960px", paddingBottom: "60px" }}>
//         {/* Page title */}
//         <h1
//           style={{
//             color: NAVY,
//             fontWeight: 900,
//             fontSize: "clamp(22px, 4vw, 36px)",
//             textAlign: "center",
//             textTransform: "uppercase",
//             letterSpacing: "1px",
//             marginBottom: "28px",
//           }}
//         >
//           Teams
//         </h1>

//         {/* Division tabs */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             gap: "10px",
//             marginBottom: "24px",
//             flexWrap: "wrap",
//           }}
//         >
//           {divisionKeys.map((key) => (
//             <button
//               key={key}
//               onClick={() => setActiveDivision(key)}
//               style={{
//                 padding: "10px 28px",
//                 borderRadius: "8px",
//                 border: `2px solid ${NAVY}`,
//                 background: activeDivision === key ? NAVY : "transparent",
//                 color: activeDivision === key ? "#fff" : NAVY,
//                 fontWeight: 700,
//                 fontSize: "14px",
//                 cursor: "pointer",
//                 transition: "all 0.2s",
//               }}
//             >
//               {DIVISIONS[key].label}
//             </button>
//           ))}
//         </div>

//         {/* Division heading + description */}
//         <div style={{ textAlign: "center", marginBottom: "24px" }}>
//           <h2
//             style={{
//               color: NAVY,
//               fontWeight: 600,
//               fontSize: "clamp(18px, 3vw, 26px)",
//               textTransform: "uppercase",
//             }}
//           >
//             {division.label}
//           </h2>
//           <p
//             style={{
//               color: NAVY,
//               fontSize: "16px",
//               maxWidth: "680px",
//               fontWeight: 600,
//               margin: "6px auto 0",
//             }}
//           >
//             {division.description}
//           </p>
//         </div>

//         {/* Pool cards grid */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 220px), 1fr))",
//             gap: "16px",
//           }}
//         >
//           {poolEntries.map(([poolName, teams]) => (
//             <PoolCard key={poolName} poolName={poolName} teams={teams} />
//           ))}
//         </div>
//       </Container>
//     </div>
//   );
// }

import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";

// ─── Colour tokens ───────────────────────────────────────────────────────────
const NAVY = "#1a237e";

// ─── All team data from screenshots ──────────────────────────────────────────
const DIVISIONS = {
  A: {
    label: "DIVISION A",
    description:
      "4-pool with Quarter-final, Semi-final & Finals 11th & 12th ranked teams to be relegated to Division 'B'",
    pools: {
      "Pool A": ["HOCKEY PUNJAB", "HOCKEY CHANDIGARH", "HOCKEY MAHARASHTRA"],
      "Pool B": [
        "HOCKEY JHARKHAND",
        "DADRA & NAGAR HAVELI AND DAMAN & DIU HOCKEY",
        "HOCKEY UNIT OF TAMIL NADU",
      ],
      "Pool C": ["UTTAR PRADESH HOCKEY", "HOCKEY HARYANA", "MANIPUR HOCKEY"],
      "Pool D": [
        "HOCKEY MADHYA PRADESH",
        "HOCKEY ASSOCIATION OF ODISHA",
        "KERALA HOCKEY",
      ],
    },
  },
  B: {
    label: "DIVISION B",
    description:
      "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'A' and last two ranked teams to be relegated to Division 'C'",
    pools: {
      "Pool A": [
        "DELHI HOCKEY",
        "HOCKEY GUJARAT",
        "HOCKEY BENGAL",
        "TELANGANA HOCKEY",
        "HOCKEY UTTARAKHAND",
      ],
      "Pool B": [
        "HOCKEY KARNATAKA",
        "CHHATTISGARH HOCKEY",
        "HOCKEY ARUNACHAL",
        "HOCKEY HIMACHAL",
        "HOCKEY BIHAR",
      ],
    },
  },
  C: {
    label: "DIVISION C",
    description:
      "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'B'",
    pools: {
      "Pool A": [
        "HOCKEY ANDHRA PRADESH",
        "HOCKEY MIZORAM",
        "LE PUDUCHERRY HOCKEY",
        "ASSAM HOCKEY",
      ],
      "Pool B": [
        "GOANS HOCKEY",
        "HOCKEY JAMMU & KASHMIR",
        "HOCKEY RAJASTHAN",
        "TRIPURA",
      ],
    },
  },
};

// ─── Hockey stick icon (left header) ─────────────────────────────────────────
function HockeyStickIcon({ color = "#FFD600", size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
      <line
        x1="12"
        y1="8"
        x2="36"
        y2="52"
        stroke={color}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path d="M36 52 Q44 56 50 50 Q54 44 44 40 L36 52Z" fill={color} />
      <ellipse cx="48" cy="54" rx="6" ry="3" fill={color} opacity="0.6" />
    </svg>
  );
}

// ─── Hockey player silhouette (right header) ──────────────────────────────────
function HockeyPlayerIcon({ color = "#FFD600", size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill={color}>
      <circle cx="62" cy="12" r="9" />
      <path d="M62 21 L55 50 L45 70 L52 72 L60 55 L65 70 L72 68 L65 48 L68 21Z" />
      <path d="M58 28 L30 45 L28 52 L20 58 L16 54 L24 46 L26 40 L55 24Z" />
      <path d="M16 54 Q8 60 10 66 Q14 70 22 64 L28 52Z" />
    </svg>
  );
}

// ─── Pool card component – Text now left-aligned ─────────────────────────────
function PoolCard({ poolName, teams }) {
  return (
    <div
      style={{
        background: NAVY,
        borderRadius: "14px",
        padding: "18px 20px 20px",
        color: "#fff",
        minWidth: 0,
      }}
    >
      {/* Pool header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "14px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <HockeyStickIcon color="#FFD600" size={28} />
          <span style={{ fontWeight: 700, fontSize: "16px" }}>
            Pool{" "}
            <span style={{ color: "#FFD600" }}>
              {poolName.replace("Pool ", "")}
            </span>
          </span>
        </div>
        <HockeyPlayerIcon color="#FFD600" size={40} />
      </div>

      {/* Team list - LEFT ALIGNED */}
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {teams.map((team) => (
          <div
            key={team}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              textAlign: "left", // ← Added
              justifyContent: "flex-start", // ← Added
            }}
          >
            <div
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <HockeyStickIcon color="#FFD600" size={16} />
            </div>
            <span
              style={{
                fontWeight: 600,
                fontSize: "13px",
                textTransform: "uppercase",
                lineHeight: 1.3,
                textAlign: "left", // ← Added
              }}
            >
              {team}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Main page component ──────────────────────────────────────────────────────
export default function SubJuniorMensHockeyTeams() {
  const divisionKeys = Object.keys(DIVISIONS);
  const [activeDivision, setActiveDivision] = useState("A");

  const division = DIVISIONS[activeDivision];
  const poolEntries = Object.entries(division.pools);

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "url('/img/bghockyimg.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* ← Return */}
      <div style={{ padding: "16px 20px", textAlign: "left" }}>
        <Button
          href="/sub-junior-mens-hockey-2026"
          style={{
            backgroundColor: NAVY,
            borderColor: NAVY,
            fontSize: "12px",
            padding: "6px 16px",
          }}
        >
          ← Return
        </Button>
      </div>

      <Container style={{ maxWidth: "960px", paddingBottom: "60px" }}>
        {/* Page title */}
        <h1
          style={{
            color: NAVY,
            fontWeight: 900,
            fontSize: "clamp(22px, 4vw, 36px)",
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: "1px",
            marginBottom: "28px",
          }}
        >
          Teams
        </h1>

        {/* Division tabs */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "24px",
            flexWrap: "wrap",
          }}
        >
          {divisionKeys.map((key) => (
            <button
              key={key}
              onClick={() => setActiveDivision(key)}
              style={{
                padding: "10px 28px",
                borderRadius: "8px",
                border: `2px solid ${NAVY}`,
                background: activeDivision === key ? NAVY : "transparent",
                color: activeDivision === key ? "#fff" : NAVY,
                fontWeight: 700,
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              {DIVISIONS[key].label}
            </button>
          ))}
        </div>

        {/* Division heading + description */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <h2
            style={{
              color: NAVY,
              fontWeight: 600,
              fontSize: "clamp(18px, 3vw, 26px)",
              textTransform: "uppercase",
            }}
          >
            {division.label}
          </h2>
          <p
            style={{
              color: NAVY,
              fontSize: "16px",
              maxWidth: "680px",
              fontWeight: 600,
              margin: "6px auto 0",
            }}
          >
            {division.description}
          </p>
        </div>

        {/* Pool cards grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill, minmax(min(100%, 220px), 1fr))",
            gap: "16px",
          }}
        >
          {poolEntries.map(([poolName, teams]) => (
            <PoolCard key={poolName} poolName={poolName} teams={teams} />
          ))}
        </div>
      </Container>
    </div>
  );
}
